import { render } from "./DotBgBtn.vue?vue&type=template&id=7c168d05"
import script from "./DotBgBtn.vue?vue&type=script&lang=js"
export * from "./DotBgBtn.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DotBgBtn.vue?vue&type=style&index=0&id=7c168d05&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__